/**
* @ngdoc service
* @name  phoenix.pxGroupItemsService
* 
* @description 
* A service that takes an array of items and groups them
* into sub-arrays
* 
**/
export function GroupItemsServiceFactory() {
	return {
		/**
		* @ngdoc method
		* @name pxGroupItemsService#groupItems
		* @methodOf phoenix.pxGroupItemsService
		* @kind function
		*
		* @description
		* Group an array of items into sub-arrays
		*
		* @param {number} items An array of items
		* @param {number} itemsInGroup Length of the sub-arrays
		* @returns {array} Array with items grouped into sub-arrays of length `itemsInGroup`
		*/
		groupItems: function (items, itemsInGroup) {
			if (!itemsInGroup) {
				return items;
			}
			var rowCount = Math.ceil(items.length / itemsInGroup);
			var tempitems = items.map(function(item) {
				return item;
			});

			var grouped = [];
			for (var x = 0; x < rowCount; x++) {
				var tiles = tempitems.splice(0, itemsInGroup);
				grouped.push(tiles);
			}
			return grouped;
		}
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/services/groupItemsService.ts